import { formatRelativeTime, getAvatarColor } from '@forwardflow/helpers/utils'
import { Lead } from '@forwardflow/services/LeadService'
import { UserAvatar } from '@forwardflow/ui'
import Icon from '@forwardflow/ui/Icons'
import { Tooltip } from 'antd'

interface LeadListItemProps {
   lead: Lead
   leadId?: number
   isSelected: boolean
   onSelect: (lead: Lead) => void
   stripHtml: (html: string) => string
}

export const LeadListItem: React.FC<LeadListItemProps> = ({
   lead,
   isSelected,
   onSelect,
   stripHtml,
}) => (
   <div
      data-testid="lead-list-item"
      className={`flex items-center p-3 pr-0 rounded-lg cursor-pointer ${
         isSelected ? '!bg-white/10' : ''
      } hover:bg-white/10`}
      onClick={() => onSelect(lead)}
   >
      <Tooltip title={lead.stageInfo?.name || ''} placement="left">
         <div>
            <UserAvatar
               backgroundColor={getAvatarColor(lead.stageInfo?.name)}
               firstName={lead?.firstName?.charAt(0)}
               className="flex-shrink-0 !w-10 !h-10 !text-[14px] !font-semibold"
            />
         </div>
      </Tooltip>

      <div className="flex items-center justify-between flex-grow min-w-0 ml-3">
         <div className="flex flex-col flex-shrink min-w-0 overflow-hidden">
            <span className="text-slate-200 text-[14px] truncate font-medium">
               {`${lead?.firstName} ${lead?.lastName}`}
            </span>
            <span className="mt-1 text-xs truncate text-white/70 text-[12px]">
               {lead.lastConversation?.content
                  ? stripHtml(lead.lastConversation?.content)
                  : ''}
            </span>
         </div>

         <div className="flex flex-col items-end justify-center gap-1">
            <div className="flex items-center justify-center">
               <div className="flex items-center mr-3">
                  {lead.lastConversation?.type === 'call' ? (
                     <Icon
                        name="Call"
                        className="fill-white/50 text-[16px] mr-2 rotate-[0deg]"
                     />
                  ) : (
                     <Icon
                        name="MessageSmIcon"
                        className="fill-white/50 text-[16px] mr-2"
                     />
                  )}
                  <div className="text-white/60 text-[14px]">
                     {lead.lastConversation?.date &&
                        formatRelativeTime(lead.lastConversation.date)}
                  </div>
               </div>
            </div>

            {lead.unreadMessages > 0 && (
               <div className="relative">
                  <div className="absolute top-0 right-5">
                     <div className="flex items-center justify-center w-4 h-4 text-xs font-bold text-white bg-purple-600 rounded-full">
                        {lead.unreadMessages}
                     </div>
                  </div>
               </div>
            )}
         </div>
      </div>
   </div>
)
